import { T } from 'gt-react';
import { useLocation, Link as RouterLink } from '@tanstack/react-router';
import {
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar';

/**
 * The two forecast surfaces as children of the Demand forecasting nav entry,
 * which itself opens the forecasting settings (overrides, outlier rules, run
 * history).
 *
 * They are one destination to a buyer — the grid and the item behind a row of
 * it — so they read as one entry that opens into two, rather than two siblings
 * competing for the same glance.
 *
 * Detail carries no search here on purpose: without a series it has nothing to
 * show, so the bare link is a way in for someone who wants the page, and the
 * useful entry point stays a click on an item in the grid.
 */
export function ForecastNavItems() {
  const { pathname } = useLocation();
  const items = [
    {
      to: '/procurement/forecast/summary',
      label: <T context="forecast sidebar sub-item">Forecast summary</T>,
    },
    {
      to: '/procurement/forecast/details',
      label: <T context="forecast sidebar sub-item">Forecast details</T>,
    },
  ];

  return (
    <SidebarMenuSub>
      {items.map((item) => (
        <SidebarMenuSubItem key={item.to}>
          <SidebarMenuSubButton asChild isActive={pathname === item.to}>
            <RouterLink to={item.to}>
              <span className="truncate">{item.label}</span>
            </RouterLink>
          </SidebarMenuSubButton>
        </SidebarMenuSubItem>
      ))}
    </SidebarMenuSub>
  );
}
